<form [formGroup]="rootForm" *ngIf="! currentControl.disabled">
  <div class="form-group form-row mx-1">
    <label mat-raised-button [matTooltip]="infoBulle" matTooltipClass="tooltip-large" [matTooltipPosition]="positionIB" [for]="idHtml">{{libelle$ | async}}
        <i *ngIf="infoBulle !== ''"  class="material-icons md-dark md-18"
        aria-hidden="true">
        info
        </i>
    </label>
    <div class="input-group">
          <input [readOnly]="afficherEnLectureSeule" (keyup)="scroll(target)" bisKeypadNavigation type="text" placeholder="JJ/MM/AAAA"
        [class.is-warning]="aErreurCroiseeActive()" [class.is-invalid]="champInvalide()"
        [class.is-valid]="champValide()" [formControlName]="labelAffichage" class="form-control" [id]="idHtml"
        [class.is-non-obligatoire]="champNonObligatoire()">
    </div>
    <bis-affiche-erreurs *ngIf="erreursAffichable()" class="col-12" [erreurs]="rootForm.get(label).errors">
    </bis-affiche-erreurs>
    <div #target></div>
  </div>
</form>